module.exports = __webpack_public_path__ + "static/media/hp-home-banner-mobile-@1x.8d33efe1.jpg";